import { render, staticRenderFns } from "./confirm-payment.vue?vue&type=template&id=4a272ce8"
import script from "./confirm-payment.vue?vue&type=script&lang=js"
export * from "./confirm-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports